export default __webpack_public_path__ + "static/media/project-2.e7195e37.PNG";